// Vergelijkingstabel met drie kolommen: zet is-scrolled zodra je opzij veegt,
// zodat de vaste labelkolom een schaduwrand krijgt, en is-scrollable zodat de
// veeg-hint alleen verschijnt als er echt iets te scrollen is.
const setup = (root) => {
  const scroller = root.querySelector('.oppie-compare__scroll');
  if (!scroller || root.dataset.scrollReady) return;
  root.dataset.scrollReady = 'true';

  const update = () => {
    const max = scroller.scrollWidth - scroller.clientWidth;
    root.classList.toggle('is-scrollable', max > 4);
    root.classList.toggle('is-scrolled', scroller.scrollLeft > 4);
  };

  scroller.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
};

const setupAll = () => document.querySelectorAll('.oppie-compare--three').forEach(setup);

setupAll();
document.addEventListener('shopify:section:load', setupAll);
